<template>
	<div>
		<BrandCategoryMapping @getList="getList" />
		<BrandMappingList
			:brandList="brandList"
			:brandListTotal="brandListTotal"
			:offset="offset"
			:limit="limit"
			@getList="getList"
			@changeOffset="updateOffset"
		/>
	</div>
</template>
<script>
	import BrandCategoryMapping from '@/components/brand/BrandCategoryMapping.vue';
	import BrandMappingList from '@/components/brand/BrandMappingList.vue';
	import { formattedDate } from '../../util';

	export default {
		components: {
			BrandCategoryMapping,
			BrandMappingList,
		},
		data() {
			return {
				brandListTotal: 0,
				brandList: [],
				offset: 0,
				limit: 10,
			};
		},
		computed: {
			brandId() {
				return this.$route.params.idBrand;
			},
		},
		created() {
			this.getList();
		},
		methods: {
			async getList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/brands/category-mapping/${this.brandId}?offset=${this.offset}&limit=${this.limit}`
					);
					this.brandList = data.brandCategoryMappingDTOList.map(
						item => {
							return {
								...item,
								createDate: formattedDate(item.createDate),
							};
						}
					);
					this.brandListTotal = data.total;
				} catch (error) {
					console.error(error);
				}
			},
			updateOffset(offset) {
				this.offset = offset;
				this.getList();
			},
		},
	};
</script>
<style lang="scss" scoped></style>
